module.exports = __webpack_public_path__ + "img/title.738371f3.svg";